import Domov from "./Domov/Domov.js";
import Členové from "./Členové/Členové.js";
import Kontakty from "./Kontakty/Kontakty.js";
import Fotogalerie from "./Fotogalerie/Fotogalerie.js";
import Historie from "./Historie/Historie.js";
import Pomoc from "./Pomoc/Pomoc.js";
import Zbírka, { ZbírkaTitle, ZbírkaNotifikace } from "./Pomoc/Zbírka/Zbírka.js";
import Podpisy, { PodpisyTitle, PodpisyNotifikace } from "./Pomoc/Podpisy/Podpisy.js";
import Vznikáme, { VznikámeTitle, VznikámeNotifikace } from "./Pomoc/Vznikáme/Vznikáme.js";
import Zdroj from "./Zdroj/Zdroj.js";
import Volby from "./Volby/Volby.js";
import Financování from "./Financování/Financování.js"

const ZbírkaPack = { Page: Zbírka, Title: ZbírkaTitle, NotificationsStack: ZbírkaNotifikace };
const PodpisyPack = { Page: Podpisy, Title: PodpisyTitle, NotificationsStack: PodpisyNotifikace };
const VznikámePack = { Page: Vznikáme, Title: VznikámeTitle, NotificationsStack: VznikámeNotifikace };

export { Domov, Členové, Kontakty, Fotogalerie, Historie, Pomoc, ZbírkaPack, PodpisyPack, VznikámePack, Zdroj, Volby, Financování};
